import request from '@/utils/request'

export function getCurrentBinding(params) {
  return request({
    url: '/homeschool/wecomSessionBinding/current',
    method: 'get',
    params
  })
}

export function searchBindingStudents(params) {
  return request({
    url: '/homeschool/wecomSessionBinding/search/students',
    method: 'get',
    params
  })
}

export function searchBindingConsultations(params) {
  return request({
    url: '/homeschool/wecomSessionBinding/search/consultations',
    method: 'get',
    params
  })
}

export function bindStudent(sessionType, sessionId, studentId) {
  return request({
    url: `/homeschool/wecomSessionBinding/bind/student/${studentId}`,
    method: 'post',
    params: { sessionType, sessionId }
  })
}

export function bindConsultation(sessionType, sessionId, consultationBookId) {
  return request({
    url: `/homeschool/wecomSessionBinding/bind/consultation/${consultationBookId}`,
    method: 'post',
    params: { sessionType, sessionId }
  })
}

export function createStudentBinding(sessionType, sessionId, data) {
  return request({
    url: '/homeschool/wecomSessionBinding/create/student',
    method: 'post',
    params: { sessionType, sessionId },
    data
  })
}

export function createConsultationBinding(sessionType, sessionId, data) {
  return request({
    url: '/homeschool/wecomSessionBinding/create/consultation',
    method: 'post',
    params: { sessionType, sessionId },
    data
  })
}

export function unbindBinding(bindingId) {
  return request({
    url: `/homeschool/wecomSessionBinding/unbind/${bindingId}`,
    method: 'post'
  })
}

export function getStudentDetail(studentId) {
  return request({
    url: `/educational/student/getStudentDetail/${studentId}`,
    method: 'get'
  })
}

export function getStudentCourseList(studentId) {
  return request({
    url: `/educational/classHour/getStudentCourseList/${studentId}`,
    method: 'get'
  })
}

export function getConsultationRecords(consultationBookId) {
  return request({
    url: `/wechatWork/consultationBook/getConsultationRecords/${consultationBookId}`,
    method: 'get'
  })
}

export function getConsultationBookDetail(consultationBookId) {
  return request({
    url: `/enrollment/consultationBook/${consultationBookId}`,
    method: 'get'
  })
}
